import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, ExternalLink, Clock, DollarSign } from 'lucide-react';
import './WebAntPayments.css';

function WebAntPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter] = useState('waiting_approval');

  useEffect(() => {
    fetchPayments();
  }, [filter]);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const res = await fetch('https://webant-lovat.vercel.app/api/payment/admin/pending-payments', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      const data = await res.json();
      
      if (data.success) {
        setPayments(data.payments || []);
      }
    } catch (error) {
      console.error('Ödemeler yüklenemedi:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (siteId) => {
    if (!window.confirm('Bu ödemeyi onaylamak istediğinize emin misiniz?')) {
      return;
    }

    try {
      const notes = prompt('Onay notu (opsiyonel):');
      
      const res = await fetch(`https://webant-lovat.vercel.app/api/payment/admin/approve/${siteId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ notes })
      });

      const data = await res.json();
      
      if (data.success) {
        alert('✅ Ödeme onaylandı! Site aktif edildi.');
        fetchPayments();
      } else {
        alert('❌ Hata: ' + data.error);
      }
    } catch (error) {
      console.error('Onaylama hatası:', error);
      alert('Bir hata oluştu');
    }
  };

  const handleReject = async (siteId) => {
    const reason = prompt('Red nedeni:');
    if (!reason) return;

    try {
      const res = await fetch(`https://webant-lovat.vercel.app/api/payment/admin/reject/${siteId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ reason })
      });

      const data = await res.json();
      
      if (data.success) {
        alert('✅ Ödeme reddedildi.');
        fetchPayments();
      } else {
        alert('❌ Hata: ' + data.error);
      }
    } catch (error) {
      console.error('Reddetme hatası:', error);
      alert('Bir hata oluştu');
    }
  };

  if (loading) {
    return (
      <div className="webant-payments-page">
        <div className="loading-spinner">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="webant-payments-page">
      <div className="page-header">
        <div>
          <h1>WebAnt Ödeme Yönetimi</h1>
          <p>Bekleyen ödemeleri onaylayın veya reddedin</p>
        </div>
        
        <div className="stats-cards">
          <div className="stat-card">
            <Clock className="stat-icon" />
            <div>
              <div className="stat-value">{payments.length}</div>
              <div className="stat-label">Bekleyen</div>
            </div>
          </div>
        </div>
      </div>

      {payments.length === 0 ? (
        <div className="empty-state">
          <Clock size={48} />
          <h3>Bekleyen Ödeme Yok</h3>
          <p>Tüm ödemeler işlenmiş durumda</p>
        </div>
      ) : (
        <div className="payments-grid">
          {payments.map((payment) => (
            <div key={payment.id} className="payment-card">
              <div className="payment-header">
                <div>
                  <h3>{payment.sites?.business_name || 'İsimsiz Site'}</h3>
                  <p className="payment-subdomain">{payment.sites?.subdomain}.webant.site</p>
                </div>
                <div className="payment-amount">
                  <DollarSign size={16} />
                  {payment.amount} ₺
                </div>
              </div>

              <div className="payment-details">
                <div className="detail-row">
                  <span className="detail-label">Sektör:</span>
                  <span className="detail-value">{payment.sites?.sector}</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Tarih:</span>
                  <span className="detail-value">
                    {new Date(payment.created_at).toLocaleDateString('tr-TR')}
                  </span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Ödeme Yöntemi:</span>
                  <span className="detail-value">{payment.payment_method}</span>
                </div>
              </div>

              {payment.receipt_url && (
                <a 
                  href={payment.receipt_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="receipt-link"
                >
                  <ExternalLink size={16} />
                  Dekont Görüntüle
                </a>
              )}

              <div className="payment-actions">
                <button
                  onClick={() => handleApprove(payment.site_id)}
                  className="btn-approve"
                >
                  <CheckCircle size={18} />
                  Onayla
                </button>
                <button
                  onClick={() => handleReject(payment.site_id)}
                  className="btn-reject"
                >
                  <XCircle size={18} />
                  Reddet
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default WebAntPayments;
